import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useRegisterComponent } from '../../../orchestrator';
import { useAppDispatch } from '../../../../stores/redux.store';
import { handleMfaPromoteUserSelection } from '../../../../actions/mfa-promote-actions';
import { useButtonClickedEvent } from '../../../../utilities/analytics/analytics-web-client';
import { pageId } from '../constants';

/**
 * Provides the handler for the "Continue without two-step verification" button.
 * When called, it will trigger a server-driven redirect back into the normal post-login flow.
 */
export const useDismissTwoStepVerification = () => {
  useRegisterComponent(useDismissTwoStepVerification.name);

  const dispatch = useAppDispatch();
  const { search } = useLocation();
  const trackDismissButtonClicked = useButtonClickedEvent(pageId, 'MfaPromoteDismiss');

  const onDismissTwoStepVerificationClicked = useCallback(() => {
    trackDismissButtonClicked();
    dispatch(handleMfaPromoteUserSelection('dismiss', search));
  }, [dispatch, search, trackDismissButtonClicked]);

  return { onDismissTwoStepVerificationClicked };
};
